
export default {
  name: "TripleBlock",
};
